<template>
  <div>
    <Alert v-if="isCalendarHeavy(program)" :type="'info'" :icon="'far fa-circle-info'">
      <p class="text-center text-3xl">
        <b>
          <p>
            Your program has many calendar date topics (e.g. May 23rd instead of June 1st)
            - they will be delivered early to prevent expiry and for better schedule smoothing.
          </p>
        </b>
      </p>
    </Alert>
  </div>
</template>

<script>
import Alert from "@components/UIComponents/Alert";

export default {
  components: { Alert },
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isCalendarHeavy(program) {
      const topicList = program.topicList;
      const totalTopicCount = topicList.length;

      let calendarCount = 0;
      for (const topic of topicList) {
        if (!topic.calendar) {
          continue;
        }
        calendarCount += 1;
      }

      const half = totalTopicCount / 2;
      return calendarCount > half;
    }
  },
};
</script>

<style lang="scss"></style>
